// CATEGORY CLASSIFIER (priority aware)

const CATEGORY_RULES = [
  {
    category: "VOCAL_GROUP",
    primary: [
      "vocal", "vocals", "vox", "leadvox", "lead vocal",
      "acapella", "a cappella", "vocal sample", "vocal loop",
      "vocal chop", "vocal phrase", "rap sample"
    ],
    secondary: [
      "hook", "chorus vox", "verse vox", "topline",
      "adlib", "adlibs", "rap", "verse", "topline loop"
    ]
  },
  {
    category: "BACKING_VOX_GROUP",
    primary: [
      "bgv", "bvox", "backing vox", "backing vocal",
      "harmony", "harmonies", "double", "doubles",
      "harmony sample", "harmony loop", "backing vocal loop"
    ],
    secondary: [
      "choir", "gang", "choir sample", "gang vocal sample"
    ]
  },
  {
    category: "KICK_GROUP",
    primary: [
      "kick", "kickin", "kickout", "808kick",
      "kick sample", "kick loop", "kick one shot",
      "kick oneshot"
    ]
  },
  {
    category: "SNARE_GROUP",
    primary: [
      "snare", "snr", "rimshot", "rim",
      "snare sample", "snare loop",
      "snare one shot", "rim sample"
    ]
  },
  {
    category: "CYMBALS_GROUP",
    primary: [
      "cymbal", "cym", "crash", "ride",
      "splash", "china",
      "crash sample", "ride sample",
      "cymbal sample", "cym loop"
    ]
  },
  {
    category: "DRUMS_GROUP",
    primary: [
      "drums", "drum", "drum bus",
      "drumkit", "kit",
      "drum sample", "drum loop",
      "drum fill", "breakbeat",
      "drum break"
    ],
    secondary: [
      "tom", "floor tom", "rack tom"
    ]
  },
  {
    category: "PERCS_GROUP",
    primary: [
      "perc", "percussion", "shaker",
      "conga", "bongo", "tamb",
      "tambourine", "claps", "clap",
      "hat", "hihat", "hh",
      "perc sample", "percussion loop",
      "shaker loop", "tamb loop",
      "conga loop", "bongo loop",
      "hat loop", "hihat loop",
      "clap loop"
    ]
  },
  {
    category: "ACOUSTIC_GUITAR_GROUP",
    primary: [
      "acoustic", "acoustic guitar",
      "acgtr", "ac gtr",
      "acoustic sample", "acoustic loop",
      "acoustic riff"
    ]
  },
  {
    category: "E_GUITAR_GROUP",
    primary: [
      "guitar", "gtr", "elec", "electric",
      "electric guitar", "lead gtr",
      "rhythm gtr", "guitar sample",
      "guitar loop", "electric loop"
    ],
    secondary: [
      "riff", "guitar riff"
    ]
  },
  {
    category: "KEYS_GROUP",
    primary: [
      "keys", "piano", "rhodes",
      "organ", "wurlitzer",
      "piano loop", "piano sample",
      "rhodes loop", "organ loop",
      "keys loop"
    ]
  },
  {
    category: "SYNTH_GROUP",
    primary: [
      "synth", "pad", "pluck",
      "arp", "arpeggio", "lead",
      "supersaw", "synth loop",
      "synth sample", "arp loop",
      "arpeggio loop", "pad loop",
      "pluck loop", "lead loop",
      "melody loop"
    ]
  },
  {
    category: "STRINGS_GROUP",
    primary: [
      "strings", "string", "violin",
      "cello", "viola", "fiddle",
      "strings loop", "string sample",
      "violin loop", "orchestral loop",
      "cello loop"
    ]
  },
  {
    category: "BRASS_GROUP",
    primary: [
      "brass", "horn", "horns",
      "trumpet", "trombone",
      "sax", "saxophone",
      "brass loop", "horn loop",
      "trumpet sample", "sax loop",
      "brass phrase"
    ]
  },
  {
    category: "BASS_GROUP",
    primary: [
      "bass", "sub", "subbass",
      "lowend", "808",
      "bass loop", "bass sample",
      "sub loop", "808 loop"
    ]
  },
  {
    category: "FX_GROUP",
    primary: [
      "fx", "sfx", "riser", "risers",
      "sweep", "whoosh", "impact",
      "transition", "drop fx",
      "ambience", "atmospheric",
      "atmos", "noise",
      "texture", "layer",
      "transition sample"
    ]
  },
  {
    category: "BACKING_TRACK_GROUP",
    primary: [
      "instrumental", "inst",
      "two track", "2track",
      "stereo", "beat",
      "backing", "music",
      "premix", "rough",
      "bounce", "print",
      "full mix",
      "instrumental loop",
      "music loop", "beat loop"
    ]
  }
];

export const inferCategoryFromName = (name) => {
  if (!name) return "OTHER_GROUP1";

  const fileName = name.split("/").pop() || "";
  const noExt = fileName.replace(/\.[^/.]+$/, "");
  const cleaned = noExt.replace(/^\d+-/, "");
  const normalized = cleaned.toLowerCase();

  // Primary match (strong confidence)
  for (const rule of CATEGORY_RULES) {
    if (rule.primary?.some(keyword => normalized.includes(keyword))) {
      return rule.category;
    }
  }

  // Secondary match (weaker confidence)
  for (const rule of CATEGORY_RULES) {
    if (rule.secondary?.some(keyword => normalized.includes(keyword))) {
      return rule.category;
    }
  }

  // Fallback
  return "OTHER_GROUP1";
};

export const generateCategoriesForArticles = (articles) => {
  const categoryMap = new Map();

  (articles || [])?.forEach((article) => {
    const category = article.category || "Uncategorized";

    categoryMap.set(
      category,
      (categoryMap.get(category) || 0) + 1
    );
  });

  const categories = [
    {
      id: "all",
      label: "All Posts",
      count: (articles || []).length,
    },
    ...Array.from(categoryMap, ([category, count]) => ({
      id: category
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, ""),

      label: category,
      count,
    })),
  ];

  return categories;
};
